// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__lNAR7","header":"MergedInvoice_header__1p_zR"};